import { axiosPut } from 'shared/api/axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import Store from 'redux/Store'
import { setMessage } from 'redux/actions'
import { AxiosError } from 'axios'

interface handleSetDefaultSortingProps {
  id: string
  setShowOverlay: Function
  setRowActionsClickCount: Function
}

const handleSetDefaultSorting = async (props: handleSetDefaultSortingProps) => {
  props.setShowOverlay(true)

  let response: any = false

  const catchFunc = (err: AxiosError) => {
    displayGenError({ setShowOverlay: props.setShowOverlay })
  }

  response = await axiosPut(
    apiUrls.deviceTableConfig + '/' + props.id + '/' + apiUrls.actionDefaultSorting,
    {},
    catchFunc,
  )

  if (response?.status === 200) {
    Store.dispatch(
      setMessage('Column successfully set as Default Sorting Column.', 'success', 'instant'),
    )
    props.setRowActionsClickCount((prevValue) => prevValue + 1)
  }
  props.setShowOverlay(false)
}

export default handleSetDefaultSorting
